import React, {Component} from "react";

class HeaderApps extends Component {
	render() {
		return (
			<div className="header__apps">
				<div className="apps-icon">
					<a href="https://m.maxline.by/">
						<i className="fas fa-mobile-alt" aria-hidden="true"></i>
					</a>
				</div>
				{/*<div className="apps-icon">*/}
					{/*<a href="#">*/}
						{/*<i className="fab fa-android" aria-hidden="true"></i>*/}
					{/*</a>*/}
				{/*</div>*/}
			</div>
		);
	}
}

export default HeaderApps;


// WEBPACK FOOTER //
// ./src/app/components/HeaderApps.js